import React from 'react';
import {
  Table,
  TableHeader,
  TableRow,
  TableHeaderCell,
  TableBody,
  TableCell,
  Button,
} from '@fluentui/react-components';
import { EditRegular, DeleteRegular } from '@fluentui/react-icons';
import { Tendering, TenderingFeeMeasure } from '../../../models/tendering';
import { getQuestionText } from '../../../utils/tendering-utils';

interface ContractFeeMeasureListProps {
  tendering: Tendering;
  measures: TenderingFeeMeasure[];
  onEdit: (measure: TenderingFeeMeasure) => void;
  onDelete: (measure: TenderingFeeMeasure) => void;
}

const ContractFeeMeasureList: React.FC<ContractFeeMeasureListProps> = ({
  tendering,
  measures,
  onEdit,
  onDelete,
}) => {
  const getQuestionTextValue = (id: number): string => {
    return getQuestionText(id, tendering.tenderingParts ?? []);
  };

  if (!measures || measures.length === 0) {
    return (
      <div className="text-gray-500 text-sm italic p-4 border border-gray-300 rounded">
        Inga mätpunkter har lagts till
      </div>
    );
  }

  return (
    <div className="border border-gray-300 rounded overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHeaderCell>Rubrik</TableHeaderCell>
            <TableHeaderCell>Värdetyp</TableHeaderCell>
            <TableHeaderCell>Typ av andel</TableHeaderCell>
            <TableHeaderCell>Andel per värdetyp</TableHeaderCell>
            <TableHeaderCell>Kopplad värdemängd (Kostnad per värdetype)</TableHeaderCell>
            <TableHeaderCell>Tillåt tom rapport</TableHeaderCell>
            <TableHeaderCell></TableHeaderCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          {measures.map((measure) => (
            <TableRow key={measure.id}>
              <TableCell>{measure.header}</TableCell>
              <TableCell>{measure.valueType}</TableCell>
              <TableCell>{measure.feeType}</TableCell>
              <TableCell>{measure.feeValue}</TableCell>
              <TableCell>
                {measure.feeType !== 'Fastpris' ? (
                  <span>{getQuestionTextValue(measure.valueQuestion!)}</span>
                ) : (
                  <span className="text-gray-500 italic">Ej relevant</span>
                )}
              </TableCell>
              <TableCell>{measure.allowEmptyReport ? 'Ja' : 'Nej'}</TableCell>
              <TableCell>
                <div className="flex gap-2">
                  <Button
                    appearance="subtle"
                    icon={<EditRegular />}
                    onClick={() => onEdit(measure)}
                    title="Redigera"
                  />
                  <Button
                    appearance="subtle"
                    icon={<DeleteRegular />}
                    onClick={() => onDelete(measure)}
                    title="Radera"
                    className="text-red-600 hover:text-red-700"
                  />
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default ContractFeeMeasureList;
